export const onlyDigits = (value?: string) => {
  if (!value) {
    return null;
  }

  return value.toString().trim().match(/\d/g)?.join('');
};
